import React, { useState } from 'react';

import ButtonLink from '@dashboard/components/mui-atoms/ButtonLink';
import BaseSettingCard from '@dashboard/components/platform-settings/BaseSettingCard';
import SectionSeparator from '@dashboard/components/SectionSeparator';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';
import { OpenInNewOutlined } from '@mui/icons-material';
import { Box, FormControlLabel, Stack, Switch, Typography } from '@mui/material';

import DataPreview from './DataPreview';
import TriggerHistoryBox from './TriggerHistoryBox';

export default function TestDataSection() {
  const platformId = useCurrentPlatformId();

  const [isCustomEnabled, setIsCustomEnabled] = useState(false);

  return (
    <Box>
      <SectionSeparator />
      <BaseSettingCard
        title="Test data"
        actions={
          <Typography variant="overline" color="text.secondary">
            Optional
          </Typography>
        }
      >
        <Typography paragraph>
          After triggering your workflow above, select or add the data you'd like to use for testing this workflow.
        </Typography>

        <Box textAlign="right">
          <FormControlLabel
            sx={{ mr: 0 }}
            label={
              <Typography variant="body2" sx={{ ml: 0.5 }}>
                Use custom test data
              </Typography>
            }
            control={
              <Switch size="small" onChange={(_, checked) => setIsCustomEnabled(checked)} checked={isCustomEnabled} />
            }
          />
        </Box>
        <Stack
          direction="row"
          sx={{ alignItems: 'stretch', height: 296, border: '1px solid', borderColor: 'divider', my: 1 }}
        >
          <TriggerHistoryBox disabled={isCustomEnabled} />
          <DataPreview editable={isCustomEnabled} />
        </Stack>
        <ButtonLink
          target="_blank"
          href={`/o/${platformId}/request-logs`}
          size="small"
          color="secondary"
          startIcon={<OpenInNewOutlined fontSize="small" />}
        >
          Debugger: View all API request logs
        </ButtonLink>
      </BaseSettingCard>
    </Box>
  );
}
